<template>
  <div class="container" style="margin-bottom: 40px">
    <case-menu @caseSelect="caseSelect"></case-menu>
    <div class="page-title">科研院所合作案例</div>
    <div style="margin-top: 90px;padding-left: 50px">
         <div class="flexRow">
           <div class="flexRow-left">
            <img  src="../../assets/img/case/fddx.png" data-aos="zoom-in" width="450px"/>
           </div>
           <div class="flexRow-right" data-aos="fade-up">
               <div class="model-ra"></div>
               <div class="icon"><img src="../../assets/img/case/fddxIcon.png" data-aos="zoom-in" width="48px"></div>
             <div class="flexRow-word">
               <div class="flex-title">复旦大学多中心生物样本库平台</div>
               <div class="flex-line"></div>
               <div class="flex-title-r">项目启动于2021年</div>
               <div class="flex-title-d">复旦大学多中心生物样本库平台面向复旦大学人类遗传资源管理需求，整合校内多所院校及附属医院的人类遗传资源，实现资源的集中展示与信息化管理。平台接入复旦大学生物医学研究院、复旦大学附属华山医院等多家机构，打造科研一体化多中心生物样本库系统。
               </div>
               <div class="flex-title-d"> 该信息化平台协助复旦大学，对其已符合《人类遗传资源管理条例》要求的人类遗传资源，实现采样、接收、存储、质控等全流程标准化管理；整合校内各单位人遗资源，统筹资源收集与应用，依托各分中心资源优势，充分挖掘临床病例数据价值，推进教研科研一体化建设。
               </div>
             </div>
           </div>
         </div>
         <div class="flexRow">
        <div class="flexRow-right" data-aos="fade-up">
          <div class="flexRow-word other-rec">
            <div class="flex-title">河北医科大学多中心专病研究平台</div>
            <div class="flex-line"></div>
            <div class="flex-title-d">
              以河北医科大学医学科研数据中心为基础，融合与建设符合国际规范的多中心专病研究平台体系，为临床科研搭建更普适、高效、真实的科研环境。
            </div>
            <div class="flex-title-ul">
              <ul>
                <li>更精确、专业、多源的数据资源</li>
                <li>灵活条件下的资源共享</li>
                <li>开放环境下的学术合作</li>
                <li>大数据助力真实世界研究</li>
              </ul>
            </div>
          </div>
        </div>
           <div class="flexRow-left" style="background: white">
             <img  src="../../assets/img/case/hbyk.png" data-aos="zoom-in" width="450px"/>
           </div>
      </div>
         <div class="flexRow">
        <div class="flexRow-left">
          <img  src="../../assets/img/case/case1Left2.png" data-aos="zoom-in" width="450px"/>
        </div>
        <div class="flexRow-right" data-aos="fade-up">
          <div class="model-ra"></div>
          <div class="icon"><img src="../../assets/img/case/zsdxLogo.png" data-aos="zoom-in" width="48px"></div>
          <div class="flexRow-word">
            <div class="flex-title">中山大学精准医学科学中心多中心生物样本平台</div>
            <div class="flex-line"></div>
<!--            <div class="flex-title-r">项目启动于2021年</div>-->
            <div class="flex-title-d">
              中山大学精准医学科学中心多中心生物样本平台接入中山大学相关附属机构，如中山大学附属第一医院、中山大学附属第二医院、中山大学附属肿瘤医院及校内各下属单位相关的样本、机构、项目等信息资源，面向多家机构相关生物资源标准化建设，同步接入相应的各家机构自动化的设备信息，进行资源聚合和统一监管，从而形成覆盖多病种、多来源、多模态、多类型的精准数据群，构建起安全、稳定、可操作的精准医学科学中心多中心生物样本平台。
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CaseMenu from "../../components/CaseMenu";
export default {
  name: "institution",
  components: {
    CaseMenu
  },
  methods:{
    caseSelect(src){
      this.$emit('caseSelect',src)
    }
  }
}
</script>

<style scoped lang="less">
.page-title{
  font-size: 36px;
  color: red;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}
.container{
  width: 100%;
  padding-left: 20%;
  box-sizing: border-box;
  position: relative;
}
.flexRow{
  display: flex;
  height: 450px;
  .flexRow-left{
    width: 50%;
    background: #0b96fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flexRow-right{
    width: 50%;

    .flexRow-word{
      position: relative;
      top: -70px;
      left: 70px;
    }
  }
  .model-ra{
         width: 48px;
         height: 48px;
         background: #6cabfe;
         position: relative;
         top: 30px;
         left: -25px;
       }
  .icon{
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #ffffff;
    position: relative;
    top: 70px;
    left: -25px;
  }
  .flex-title{
    font-size: 19px;
    color: #006efd;
    font-weight: bold;
  }
  .flex-line{
    margin-top: 15px;
    width: 70px;
    height: 6px;
    background: #0b96fa;
  }
  .flex-title-r{
    font-size: 16px;
    margin-top: 30px;
  }
  .flex-title-d{
    width: 80%;
    font-size: 16px;
    margin-top: 30px;
    line-height: 30px;
    text-align: justify-all;
    text-indent: 32px;
  }
  .other-rec{
    margin-top: 30px;
    position: relative;
    top: 0px!important;
    left: 0px!important;
  }
  .flex-title-ul{
    width: 100%;
    height: 40%;
    display: flex;
    align-items: center;
    justify-content: start;
    font-size: 16px;
    padding-top: 40px;
    padding-left: 40px;
    li{
      height: 40px;
    }
  }

}
</style>
